import { onViewLoad } from "jose_modern/on_view_load.js";

onViewLoad("similar#show", () => {
  const slider = document.querySelector("#similarity");
  const value = document.querySelector("[data-similarity-value]");

  if (!slider || !value) return;

  slider.addEventListener("input", () => {
    value.textContent = `${slider.value}%`;
  });
});
